import script from "./EncontrosListagemAtividade.vue?vue&type=script&setup=true&lang=js"
export * from "./EncontrosListagemAtividade.vue?vue&type=script&setup=true&lang=js"

import "./EncontrosListagemAtividade.vue?vue&type=style&index=0&id=3b12d2d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b12d2d8"]])

export default __exports__